import type { EliteAffixId } from "./schemas";

export type EliteAffixDef = {
  id: EliteAffixId;
  name: string;
  description: string;
  color: number;
  hullMult: number;
  speedMult: number;
  shieldMult: number;
};

export const ELITE_AFFIXES: Record<EliteAffixId, EliteAffixDef> = {
  volatile: {
    id: "volatile",
    name: "Volatile",
    description: "Explodes on death",
    color: 0xff4422,
    hullMult: 0.85,
    speedMult: 1,
    shieldMult: 1,
  },
  phasing: {
    id: "phasing",
    name: "Phasewake",
    description: "Erratic high-speed movement",
    color: 0xaa66ff,
    hullMult: 0.9,
    speedMult: 1.15,
    shieldMult: 1,
  },
  vampiric: {
    id: "vampiric",
    name: "Vampiric",
    description: "Heals on hit",
    color: 0xcc2244,
    hullMult: 1.1,
    speedMult: 1,
    shieldMult: 1,
  },
  shielded: {
    id: "shielded",
    name: "Shielded",
    description: "Extra shield capacity",
    color: 0x6ec6ff,
    hullMult: 1,
    speedMult: 0.95,
    shieldMult: 1.8,
  },
  armored: {
    id: "armored",
    name: "Armored",
    description: "Reinforced hull",
    color: 0x888888,
    hullMult: 1.5,
    speedMult: 0.85,
    shieldMult: 1,
  },
  swift: {
    id: "swift",
    name: "Swift",
    description: "High mobility",
    color: 0xffcc44,
    hullMult: 0.9,
    speedMult: 1.35,
    shieldMult: 1,
  },
};

export const ELITE_AFFIX_IDS = Object.keys(ELITE_AFFIXES) as EliteAffixId[];

export function rollEliteAffix(seed: number, enemyId: number, tick: number): EliteAffixId {
  const idx = Math.abs(hashMix(seed, enemyId, tick)) % ELITE_AFFIX_IDS.length;
  return ELITE_AFFIX_IDS[idx]!;
}

function hashMix(seed: number, enemyId: number, tick: number): number {
  return (seed * 31 + enemyId * 17 + tick * 7) | 0;
}
